module.exports = __webpack_public_path__ + "fonts/VetoSans-Italic.478e5302.ttf";